import { CheckCircle, AlertCircle, AlertTriangle, Info, X } from 'lucide-react';
export const TOAST_CONFIG = {
    minHeight: 44,
    maxWidth: 420,
    mobileBreakpoint: 640,
    mobileWidth: '90vw',
    padding: {
        vertical: 16,
        horizontal: 20,
    },
    borderRadius: 8,
    iconSize: 20,
    closeButtonSize: 20,
    animationDuration: 200,
};
/** The card and its stack slot open together (WEB-1123), so they share one transition. */
export const TOAST_TRANSITION = {
    duration: TOAST_CONFIG.animationDuration / 1000,
    ease: 'easeOut',
};
/**
 * Custom property a host's toast region sets to size every `Toast` inside it
 * (WEB-1109). Unset, a toast is `min(mobileWidth, maxWidth)`.
 */
export const TOAST_WIDTH_VAR = '--toast-width';
export const getToastStyles = (theme) => ({
    success: {
        background: theme.colors.success,
        border: theme.colors.success,
        text: theme.colors.background,
        icon: CheckCircle,
    },
    error: {
        background: theme.colors.error,
        border: theme.colors.error,
        text: theme.colors.background,
        icon: AlertCircle,
    },
    warning: {
        background: theme.colors.warning,
        border: theme.colors.warning,
        // WEB-1100: amber needs dark ink in BOTH themes. `background` is white in
        // light (2.71:1 on #CC9300), so light takes the `text` ink instead
        // (#1E2B4B, ≈5.2:1); dark keeps `background` (#0F141F on #FFCC40).
        text: theme.mode === 'light' ? theme.colors.text : theme.colors.background,
        icon: AlertTriangle,
    },
    info: {
        background: theme.colors.primary,
        border: theme.colors.primary,
        text: theme.colors.background,
        icon: Info,
    },
});
export const XIcon = X;
